import Env from '../base/env.js'
import Channels from '../base/channels.js'
import gsap from 'gsap'

class MainnavTouch
{
    constructor()
    {
        if(Env.$mainNav == null) {
            return false
        }
        this.view = Env.$mainNav
        this.$triggers = Env.$body.querySelectorAll('.jsMainnav--trigger')
        this.$fill = this.view.querySelector('.jsFill-bg')
        this.$primary = this.view.querySelector('.jsMainnav')
        this.$lines = this.$fill.querySelectorAll('.jsLineSizer')
        this.$lineSizer = this.$fill.querySelector('.jsLineReceptor')
        this.$linesAnim = this.view.querySelectorAll('.jsLineAnim')
        this.$itemsTxt = this.view.querySelectorAll('.jsTxt')
        // Flags
        this.IS_ANIMATING = false
        // Fns
        this.events()
        this.resize()
    }
    events()
    {
        var
        self = this

        for ( const e of this.$triggers ) {
            e.addEventListener('click',()=>{
                if(this.IS_ANIMATING == false)
                {
                    this.toggle()
                }
                return false;
            },false)
        }

        Channels.on('mainnav::close',()=>
        {
            this.close()
        })

        Channels.on('window::smartresize',()=>{
            if(Env.mobileCSS === false)
            {
                // gsap.set(this.$primary,{ clearProps : 'opacity' })
                this.resize()
                if(this.view != null) {
                    this.view.removeAttribute('style')
                }
            }
        })
    }

    getStatus()
    {
        return this.view.classList.contains('is--active')
    }

    close(funcStart=null,funcComplete=null)
    {
        this.out(
            ()=>{
                Channels.emit('mainnav::closing')
                this.IS_ANIMATING = true
                this.view.classList.remove('is--active');
                Env.$html.classList.remove('mainnav--isOpened')
                Env.$html.classList.add('mainnav--isLeaving')
                Env.$html.classList.remove('mainnav--isFinalize')
                if(typeof funcStart == 'function' || funcStart != null) funcStart()
            },
            ()=>{
                this.IS_ANIMATING = false
                Env.$html.classList.remove('mainnav--isLeaving')
                Env.$html.classList.remove('mainnav--isFinalize')
                if(typeof funcComplete == 'function' || funcComplete != null) funcComplete()
            }
        )
    }

    in(funcStart='',funcComplete='')
    {

        let timeline = gsap.timeline({
            onStart:()=>{
                this.status = 'animating'
                if(typeof funcStart == 'function' || funcStart != null) funcStart()
            },
            onComplete:()=>{
              this.status = 'in'
              Env.$html.classList.add('mainnav--isFinalize')
              if(typeof funcComplete == 'function' || funcComplete != null) funcComplete()
            }
        })

        timeline.add(()=>{
          gsap.set(this.$fill, { autoAlpha:1 })
          gsap.set(this.$primary, { autoAlpha: 1 })
        })
        timeline.add([
          gsap.fromTo(this.$linesAnim,
            {
              x: '-100%'
            },
            {
              x: '0%',
              ease: 'quint.inOut',
              duration:1,
              stagger:.1,
              delay: 0
            }
          ),
        ])
        timeline.add([
          gsap.fromTo(this.$itemsTxt,
            {
              autoAlpha: 0,
              x:-80
            },
            {
              x:0,
              autoAlpha : 1,
              ease: 'quint.out',
              delay: 0,
              duration:.8,
              stagger:.08
            },
          ),
        ],'-=1')
    }

    out(funcStart='',funcComplete='')
    {

        let timeline = gsap.timeline({
            onStart:()=>{
                this.status = 'animating'
                if(typeof funcStart == 'function' || funcStart != null) funcStart()
            },
            onComplete:()=>{
                this.status = 'out'
                gsap.set(this.$fill, { autoAlpha:0 })
                gsap.set(this.$primary, { autoAlpha: 0 })
                if(typeof funcComplete == 'function' || funcComplete != null) funcComplete()
            }
        })

        timeline.add([
          gsap.to(this.$itemsTxt,
            {
              x:80,
              autoAlpha : 0,
              ease: 'quint.in',
              delay: 0,
              duration:.35,
              stagger:.1
            },
          ),
          gsap.to(this.$linesAnim,
            {
              x: '100%',
              ease: 'quint.inOut',
              duration:1,
              stagger:.1,
              delay: 0
            }
          ),
        ])
    }

    resize()
    {
      let memoHeight = 0
      const viewport = Env.framework.toolbox.getViewport()
      for(let line of this.$lines) {
        const coord = line.getBoundingClientRect()
        memoHeight += coord.height
      }
      const diff = viewport.height - memoHeight
      gsap.set(this.$lineSizer, { height: diff})

    }

    toggle(_status)
    {
        if (typeof _status === 'undefined')
            _status = this.view.classList.contains('is--active')

        if(!!_status)
        {
            this.close()
        }
        else
        {
            this.in(
                ()=>{
                    this.IS_ANIMATING = true
                    this.view.classList.add('is--active');
                    Env.$html.classList.add('mainnav--isOpened')
                },
                ()=>{

                    this.IS_ANIMATING = false
                }
            )
        }
    };
}

export default MainnavTouch;
